var _a;
import { ENTER, SPACE } from '../key_codes';
// These keys are used to execute click actions on interactive elements like buttons and links.
export var accessibleClickKeys = (_a = {},
    _a[ENTER] = 'enter',
    _a[SPACE] = 'space',
    _a);
